import { Component, type ErrorInfo, type ReactNode } from 'react';
import { toAppError } from '../../lib/errors';

// Global error boundary (foundation). Catches render-time errors so the whole app never
// white-screens. Presentation is intentionally minimal until the design system (6.2).
interface Props {
  readonly children: ReactNode;
}

interface State {
  readonly error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error: toAppError(error) };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    // Foundation logging only; a reporting sink is a later concern.
    console.error('Unhandled UI error', toAppError(error), info.componentStack);
  }

  private readonly handleReset = (): void => {
    this.setState({ error: null });
  };

  override render(): ReactNode {
    const { error } = this.state;
    if (error === null) {
      return this.props.children;
    }
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-6 text-center">
        <p className="text-danger">დაფიქსირდა შეცდომა</p>
        <button
          type="button"
          onClick={this.handleReset}
          className="rounded-token border border-border px-4 py-2 text-fg"
        >
          თავიდან ცდა
        </button>
      </div>
    );
  }
}
